import { render } from "./header.vue?vue&type=template&id=38a8d65a&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=38a8d65a&scoped=true&lang=css"

import exportComponent from "/var/www/clients/client2/web300/web/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a8d65a"]])

export default __exports__